import { AvatarProps, IMessage } from 'react-native-gifted-chat';

import type { RenderContext } from './RenderContext';

import { primum_default_avatar } from '@/assets/images';
import { ICustomMessage } from '@/components/chat';
import { Avatar, AvatarImage } from '@/components/ui/avatar';
import { PRIMUM_SUPPORT_USER } from '@/constants/users';
import { MESSAGE_DATA_TYPES } from '@/types/messageData';
import { isAskAnonymouslyRoutedInquiry } from '@/util/inquiryDisplay';

/**
 * Builds the GiftedChat `renderAvatar` callback. Ask Anonymously expert-relay
 * rows and Primum Support rows show the support avatar; everything else uses
 * the sender's profile avatar with a default fallback.
 */
export function makeRenderAvatar(ctx: Pick<RenderContext, 'inquiry'>) {
  return function renderAvatar({ currentMessage }: AvatarProps<IMessage>) {
    const msg = currentMessage as ICustomMessage;

    /** Relay rows are sent by Primum, not the named expert; keep Ask Anon / support branding. */
    const isExpertRelayRow =
      isAskAnonymouslyRoutedInquiry(ctx.inquiry) &&
      (msg?.contentRole === 'expert_relay' || msg?.type === MESSAGE_DATA_TYPES.EXPERT_RELAY);

    const isPrimumSupport = currentMessage?.user._id === PRIMUM_SUPPORT_USER.id;

    let avatarSource = primum_default_avatar;

    if (isExpertRelayRow || isPrimumSupport) {
      avatarSource = { uri: PRIMUM_SUPPORT_USER.avatarSrc };
    } else if (currentMessage?.user.avatar) {
      avatarSource = { uri: currentMessage.user.avatar.toString() };
    }

    return (
      <Avatar size="sm" className="mr-1">
        <AvatarImage source={avatarSource} />
      </Avatar>
    );
  };
}
